<template>
<div class="wrapper">

  <!-- content-box -->
  <div class="content-box">
    <div class="content-inner">
      <h2 class="h2">Test Result</h2>
      <div class="tableWrap">
        <div class="titArea">
          <h3 class="tit">Summary</h3>
        </div>
        <div class="innerTable">
          <div class="scrollX">
            <div class="tableSt01">
              <table>
                <colgroup>
                  <col width="160px" />
                  <col width="120px" />
                  <col width="96px" />
                  <col width="340px" />
                  <col width="*" />
                </colgroup>
                <thead>
                  <tr class="only">
                    <th>
                      <div class="inbox">
                        <div class="str">
                          <strong>Date &amp; Time</strong>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div class="inbox">
                        <div class="str">
                          <strong>Package Name</strong>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div class="inbox">
                        <div class="str">
                          <strong>App Version</strong>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div class="inbox">
                        <div class="str">
                          <strong>App Info</strong>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div class="inbox">
                        <div class="str">
                          <strong>Test Result</strong>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
              </table>
              <div class="scroll">
                <div class="tableSt01">
                  <table>
                    <colgroup>
                  <col width="160px" />
                  <col width="120px" />
                  <col width="96px" />
                  <col width="340px" />
                  <col width="*" />
                </colgroup>
                    <tbody>
                      <tr>
                        <td>
                          <div><p>210325 02:00 pm</p></div>
                        </td>
                        <td>
                          <div><p>com.waze</p></div>
                        </td>
                        <td>
                          <div><p>1.2.2</p></div>
                        </td>
                        <td>
                          <div><p>
                            Minimum SDK: 21<br>
                            Native Code : arm64-v8a, armeabi-v7a,x86,x86_64<br>
                            Screens: small, normal, large, xlarge<br>
                            Target SDK 29<br>
                            Version Code 10202010<br>
                            Activity com.waze.search.hompage
                          </p></div>
                        </td>
                        <td>
                          <div><p>
                            Pass / Total 6/10<br>
                            Detailed Fail Info<br>
                            - OS 11  : API/Permission usage: 1, <br>
                            Deprecated API 3, Engine: 1<br>
                            - OS 10 : …
                          </p></div>
                        </td>
                      </tr>
                    </tbody>
                  </table>      
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="tableWrap">
        <div class="titArea">
          <h3 class="tit">Detail Information</h3>
          <div class="table-filter">
            <div class="filter-item short">
              <span class="title">Search by</span>
              <a href="#;" class="selected-text"><span>All</span></a>
              <!-- 토글 시 .active 클래스 추가 -->
              <div class="dropdown-wrap">
                <ul>
                  <li><a href="#;">All</a></li>
                  <li><a href="#;">Test No.</a></li>
                  <li><a href="#;">Test Type</a></li>
                  <li><a href="#;">OS</a></li>
                  <li><a href="#;">Item</a></li>
                  <li><a href="#;">Result</a></li>
                  <li><a href="#;">App Info</a></li>
                </ul>
              </div>
            </div>
            <div class="filter-item">
              <span class="title">Search</span>
              <div class="input-text search">
                <input type="text" name="" id="" value="" placeholder="Search"><button type="button"><img src="/images/btn_close.png" alt=""></button>
              </div>
            </div>
            <div class="alignRight">
              <button type="button" class="excel" data-pop="excel-pop">Export</button>
            </div>
          </div>
        </div>
        <div class="innerTable">
          <div class="scrollX">
            <div class="tableSt01">
              <table>
                <colgroup>
                  <col width="96px" />
                  <col width="104px" />
                  <col width="76px" />
                  <col width="96px" />
                  <col width="96px" />
                  <col width="372px" />
                  <col width="*" />
                </colgroup>
                <thead>
                  <tr>
                    <th>
                      <div class="inbox">
                        <div class="str">
                          <strong>Test No.</strong>
                          <button class="sort"  type="button"><img src="/images/btn_sort.png" alt=""></button>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div class="inbox">
                        <div class="str">
                          <strong>Test Type</strong>
                          <button class="sort"  type="button"><img src="/images/btn_sort.png" alt=""></button>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div class="inbox">
                        <div class="str">
                          <strong>OS</strong>
                          <button class="sort"  type="button"><img src="/images/btn_sort.png" alt=""></button>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div class="inbox">
                        <div class="str">
                          <strong>Item</strong>
                          <button class="sort"  type="button"><img src="/images/btn_sort.png" alt=""></button>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div class="inbox">
                        <div class="str">
                          <strong>Result</strong>
                          <button class="sort"  type="button"><img src="/images/btn_sort.png" alt=""></button>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div class="inbox">
                        <div class="str">
                          <strong>App Info</strong>
                          <button class="sort"  type="button"><img src="/images/btn_sort.png" alt=""></button>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div class="inbox">
                        <div class="str">
                          <strong>Quick Feedback</strong>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
              </table>
              <div class="">
                <table>
                  <colgroup>
                    <col width="96px" />
                    <col width="104px" />
                    <col width="76px" />
                    <col width="96px" />
                    <col width="96px" />
                    <col width="372px" />
                    <col width="*" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td>
                        <div><p>15</p></div>
                      </td>
                      <td>
                        <div><p>API/Permission usage</p></div>
                      </td>
                      <td>
                        <div><p>11</p></div>
                      </td>
                      <td>
                        <div><p>getNetworkType</p></div>
                      </td>
                      <td>
                        <div><p>Fail</p></div>
                      </td>
                      <td>
                        <div><p>
                          This method was deprecated in API<br>
                          level 30.  use getDataNetworkType() public int getNetworkType () Return the current data network type. RequiresManifest.permission.READ_PHONE_STAT
                        </p></div>
                      </td>
                      <td class="center">
                        <div>
                          <div class="filter-item">
                            <a href="#;" class="selected-text"><span>Complete</span></a>
                            <!-- 토글 시 .active 클래스 추가 -->
                            <div class="dropdown-wrap">
                              <ul>
                                <li><a href="#;">Complete</a></li>
                                <li><a href="#;">Pending</a></li>
                                <li><a href="#;">Rejected</a></li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div><p>15</p></div>
                      </td>
                      <td>
                        <div><p>API/Permission usage</p></div>
                      </td>
                      <td>
                        <div><p>11</p></div>
                      </td>
                      <td>
                        <div><p>getNetworkType</p></div>
                      </td>
                      <td>
                        <div><p>Fail</p></div>
                      </td>
                      <td>
                        <div><p>
                          This method was deprecated in API<br>
                          level 30.  use getDataNetworkType() public int getNetworkType () Return the current data network type. RequiresManifest.permission.READ_PHONE_STAT
                        </p></div>
                      </td>
                      <td class="center">
                        <div>
                          <div class="filter-item">
                            <a href="#;" class="selected-text"><span>Complete</span></a>
                            <!-- 토글 시 .active 클래스 추가 -->
                            <div class="dropdown-wrap">
                              <ul>
                                <li><a href="#;">Complete</a></li>
                                <li><a href="#;">Pending</a></li>
                                <li><a href="#;">Rejected</a></li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div><p>15</p></div>
                      </td>
                      <td>
                        <div><p>API/Permission usage</p></div>
                      </td>
                      <td>
                        <div><p>11</p></div>
                      </td>
                      <td>
                        <div><p>getNetworkType</p></div>
                      </td>
                      <td>
                        <div><p>Fail</p></div>
                      </td>
                      <td>
                        <div><p>
                          This method was deprecated in API<br>
                          level 30.  use getDataNetworkType() public int getNetworkType () Return the current data network type. RequiresManifest.permission.READ_PHONE_STAT
                        </p></div>
                      </td>
                      <td class="center">
                        <div>
                          <div class="filter-item">
                            <a href="#;" class="selected-text"><span>Complete</span></a>
                            <!-- 토글 시 .active 클래스 추가 -->
                            <div class="dropdown-wrap">
                              <ul>
                                <li><a href="#;">Complete</a></li>
                                <li><a href="#;">Pending</a></li>
                                <li><a href="#;">Rejected</a></li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div><p>15</p></div>
                      </td>
                      <td>
                        <div><p>API/Permission usage</p></div>
                      </td>
                      <td>
                        <div><p>11</p></div>
                      </td>
                      <td>
                        <div><p>getNetworkType</p></div>
                      </td>
                      <td>
                        <div><p>Fail</p></div>
                      </td>
                      <td>
                        <div><p>
                          This method was deprecated in API<br>
                          level 30.  use getDataNetworkType() public int getNetworkType () Return the current data network type. RequiresManifest.permission.READ_PHONE_STAT
                        </p></div>
                      </td>
                      <td class="center">
                        <div>
                          <div class="filter-item">
                            <a href="#;" class="selected-text"><span>Complete</span></a>
                            <!-- 토글 시 .active 클래스 추가 -->
                            <div class="dropdown-wrap">
                              <ul>
                                <li><a href="#;">Complete</a></li>
                                <li><a href="#;">Pending</a></li>
                                <li><a href="#;">Rejected</a></li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div><p>15</p></div>
                      </td>
                      <td>
                        <div><p>API/Permission usage</p></div>
                      </td>
                      <td>
                        <div><p>11</p></div>
                      </td>
                      <td>
                        <div><p>getNetworkType</p></div>
                      </td>
                      <td>
                        <div><p>Fail</p></div>
                      </td>
                      <td>
                        <div><p>
                          This method was deprecated in API<br>
                          level 30.  use getDataNetworkType() public int getNetworkType () Return the current data network type. RequiresManifest.permission.READ_PHONE_STAT
                        </p></div>
                      </td>
                      <td class="center">
                        <div>
                          <div class="filter-item">
                            <a href="#;" class="selected-text"><span>Complete</span></a>
                            <!-- 토글 시 .active 클래스 추가 -->
                            <div class="dropdown-wrap">
                              <ul>
                                <li><a href="#;">Complete</a></li>
                                <li><a href="#;">Pending</a></li>
                                <li><a href="#;">Rejected</a></li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="infoTable">
          <span>Rows per page :</span>
          <div class="selects type03">
            <button type="button" class="off">5</button>
            <ul>
              <li><button type="button">5</button></li>
            </ul>
          </div>
          <span>1-5 of 999</span>
          <div class="btns">
            <button type="button" class="prev"><img src="/images/arrow.png" alt=""></button>
            <button type="button"><img src="/images/arrow.png" alt=""></button>
          </div>
        </div>
      </div>

      <div class="tableWrap">
        <div class="titArea">
          <h3 class="tit">Recently Updated Comments</h3>
          <div class="table-filter">
            <div class="filter-item short">
              <span class="title">Test No.</span>
              <a href="#;" class="selected-text" data-name="Num"><span>All</span></a>
              <!-- 토글 시 .active 클래스 추가 -->
              <div class="dropdown-wrap">
                <ul>
                  <li><a href="#;">All</a></li>
                  <li><a href="#;">5</a></li>
                  <li><a href="#;">4</a></li>
                  <li><a href="#;">3</a></li>
                  <li><a href="#;">2</a></li>
                  <li><a href="#;">1</a></li>
                </ul>
              </div>
            </div>
            <div class="filter-item long">
              <span class="title">Search</span>
              <div class="input-text search">
                <input type="text" name="" id="" value="" placeholder="Search"><button type="button"><img src="/images/btn_close.png" alt=""></button>
              </div>
            </div>
            <div class="alignRight">
              <div class="filter-item">
                <span class="title">Date</span>
                <div class="picker-wrap">
                  <date-picker :editable="false" v-model="time1" type="date" range :format="format" @change="toggleFooter" @open="open" @close="close" ref="datepicker" :lang="lang" placeholder="Select Datetime">
                    <template v-slot:header="{ emit }">
                      <button class="mx-btn mx-btn-text" @click="selectPrev7Day(emit)">Previous 7 Days</button>
                      <button class="mx-btn mx-btn-text" @click="selectPrev30Day(emit)">Previous 30 Days</button>
                      <button class="mx-btn mx-btn-text" @click="selectPrev60Day(emit)">Previous 60 Days</button>
                      <button class="mx-btn mx-btn-text" @click="selectPrev90Day(emit)">Previous 90 Days</button>
                    </template>
                    <template v-slot:footer="{  }">
                      <button class="mx-btn mx-btn-text" @click="handleApply">OK</button>
                    </template>
                    <i slot="icon-clear"><span class="clear-icon"><img src="/images/btn_close.png" alt=""></span></i>
                  </date-picker>
                </div>
              </div>
              <div class="filter-item short">
                <span class="title">Search by</span>
                <a href="#;" class="selected-text"><span>Oldest</span></a>
                <!-- 토글 시 .active 클래스 추가 -->
                <div class="dropdown-wrap">
                  <ul>
                    <li><a href="#;">Oldest</a></li>
                    <li><a href="#;">Newest</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="comment-list">
            <span class="num">1,234 Comments</span>
            <ul>
              <li>
                <div class="article">
                  <div class="header">
                    <div class="comment-info">
                      <span class="avatar" style="background-image: url(/images/img-ic-illust-profile.png);"></span>
                      <div class="right">
                        <div class="detail">
                          <span class="email">abc123@company.com</span>
                          <span class="num">#5</span>
                          <span class="date">2021-05-07 04:00 PM</span>
                        </div>
                        <div class="more">
                          <button type="button"><img src="/images/icon_option.png" alt="more"></button>
                          <div class="dropdown-wrap">
                            <ul>
                              <li><button type="button" data-pop="edit-comment-pop">Edit comment</button></li>
                              <li><button type="button" data-pop="del-pop">Delete comment</button></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="comment">
                    <p>
                     <a href="#;">@Samsung</a> Could you fix this issue in the next OS, SOS? If you have a fix plan for the issue, please share the schedule.<br>
                     Also, I checked this issue using chrome browser. When I tested to download the file name included unsupported special characters using pc chrome browser, mobile chrome browser, unsupported special characters are replaced to ".' character. <br>
                     ex) 1:2/3/4.jpg ==> 1_2_3_4.jpg.
                    </p>
                    <div class="attached-item">
                      <a href="#;" download="" class="name">[SDP] Remote Test Lab_Test Feature.apk</a>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="article">
                  <div class="header">
                    <div class="comment-info">
                      <span class="avatar" style="background-image: url(/images/img-ic-illust-profile.png);"></span>
                      <div class="right">
                        <div class="detail">
                          <span class="email">abc123@company.com</span>
                          <span class="num">#5</span>
                          <span class="date">2021-05-07 06:30 PM</span>
                        </div>
                        <div class="more">
                          <button type="button"><img src="/images/icon_option.png" alt="more"></button>
                          <div class="dropdown-wrap">
                            <ul>
                              <li><button type="button" data-pop="edit-comment-pop">Edit comment</button></li>
                              <li><button type="button" data-pop="del-pop">Delete comment</button></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="comment">
                    <p>
                     <a href="#;">@Galaxy_999</a> We don't have a fix for this planned yet, our team can look at prioritizing this issue among other features for Android S.
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="article">
                  <div class="header">
                    <div class="comment-info">
                      <span class="avatar" style="background-image: url(/images/img-ic-illust-profile-2.png);"></span>
                      <div class="right">
                        <div class="detail">
                          <span class="email">Galaxy_999@samsung.com</span>
                          <span class="num">#5</span>
                          <span class="date">2021-05-07 06:30 PM</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="comment">
                    <p>
                     <a href="#;">@Samsung</a> Also, I checked this issue using chrome browser.
                    </p>
                    <div class="attached-item">
                      <a href="#;" download="" class="name">[SDP] Remote Test Lab_Test Feature_2.apk</a>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="article">
                  <div class="header">
                    <div class="comment-info">
                      <span class="avatar" style="background-image: url(/images/img-ic-illust-profile.png);"></span>
                      <div class="right">
                        <div class="detail">
                          <span class="email">abc123@company.com</span>
                          <span class="num">#5</span>
                          <span class="date">2021-05-07 06:30 PM</span>
                        </div>
                        <div class="more">
                          <button type="button"><img src="/images/icon_option.png" alt="more"></button>
                          <div class="dropdown-wrap">
                            <ul>
                              <li><button type="button" data-pop="edit-comment-pop">Edit comment</button></li>
                              <li><button type="button" data-pop="del-pop">Delete comment</button></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="comment">
                    <p>
                      When I tested to download the file name included unsupported special characters using pc chrome browser, mobile chrome browser, unsupported special characters are replaced to '-' character.
                    </p>
                    <div class="attached-item">
                      <a href="#;" download="" class="name">[SDP] Remote Test Lab_Test Feature.apk</a>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="article">
                  <div class="header">
                    <div class="comment-info">
                      <span class="avatar" style="background-image: url(/images/img-ic-illust-profile-2.png);"></span>
                      <div class="right">
                        <div class="detail">
                          <span class="email">Galaxy_999@samsung.com</span>
                          <span class="num">#5</span>
                          <span class="date">2021-05-07 06:30 PM</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="comment">
                    <p>
                     Also, I checked this issue using chrome browser. <a href="#;">@abc123</a>
                    </p>
                    <div class="attached-item">
                      <a href="#;" download="" class="name">[SDP] Remote Test Lab_Test Feature_2.apk</a>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="article">
                  <div class="header">
                    <div class="comment-info">
                      <span class="avatar" style="background-image: url(/images/img-ic-illust-profile.png);"></span>
                      <div class="right">
                        <div class="detail">
                          <span class="email">abc123@company.com</span>
                          <span class="num">#5</span>
                          <span class="date">2021-05-07 06:30 PM</span>
                        </div>
                        <div class="more">
                          <button type="button"><img src="/images/icon_option.png" alt="more"></button>
                          <div class="dropdown-wrap">
                            <ul>
                              <li><button type="button" data-pop="edit-comment-pop">Edit comment</button></li>
                              <li><button type="button" data-pop="del-pop">Delete comment</button></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="comment">
                    <p>
                      Also, I checked this issue using chrome browser. <a href="#;">@abc123</a>
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="article">
                  <div class="header">
                    <div class="comment-info">
                      <span class="avatar" style="background-image: url(/images/img-ic-illust-profile-2.png);"></span>
                      <div class="right">
                        <div class="detail">
                          <span class="email">Galaxy_999@samsung.com</span>
                          <span class="num">#5</span>
                          <span class="date">2021-05-07 06:30 PM</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="comment">
                    <p>
                      Could you fix this issue in the next OS, SOS? <a href="#;">@Samsung</a> If you have a fix plan for the issue, please share the schedule.
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="article">
                  <div class="header">
                    <div class="comment-info">
                      <span class="avatar" style="background-image: url(/images/img-ic-illust-profile.png);"></span>
                      <div class="right">
                        <div class="detail">
                          <span class="email">abc123@company.com</span>
                          <span class="num">#5</span>
                          <span class="date">2021-05-07 06:30 PM</span>
                        </div>
                        <div class="more">
                          <button type="button"><img src="/images/icon_option.png" alt="more"></button>
                          <div class="dropdown-wrap">
                            <ul>
                              <li><button type="button" data-pop="edit-comment-pop">Edit comment</button></li>
                              <li><button type="button" data-pop="del-pop">Delete comment</button></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="comment">
                    <p>
                       <a href="#;">@abc123</a> Also, I checked this issue using chrome browser.
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="article">
                  <div class="header">
                    <div class="comment-info">
                      <span class="avatar" style="background-image: url(/images/img-ic-illust-profile-2.png);"></span>
                      <div class="right">
                        <div class="detail">
                          <span class="email">Galaxy_999@samsung.com</span>
                          <span class="num">#5</span>
                          <span class="date">2021-05-07 06:30 PM</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="comment">
                    <p>
                      <a href="#;">@Samsung</a> Could you fix this issue in the next OS, SOS? If you have a fix plan for the issue, please share the schedule.<br>
                      Also, I checked this issue using chrome browser. When I tested to download the file name included unsupported special characters using pc chrome browser, mobile chrome browser, unsupported special characters are replaced to ".' character. <br>
                      ex) 1:2/3/4.jpg ==> 1_2_3_4.jpg.
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="comment-wrap">
        <div class="comment-head">
          <div class="issue-info">
            <span class="no">Test No. : </span>
            <div class="input-text">
              <input type="text" name="issueNo" id="issueNo" value="" placeholder="Input Only Number">
            </div>
          </div>
          <div class="input-file">
            <input type="file" name="issueFile" id="issueFile">
            <label for="issueFile"></label>
          </div>
        </div>
        <div class="comment active">
          <!-- textarea 활성화 시 .active 추가 -->
          <textarea name="comment" id="comment" class="textarea" placeholder="Please write down your opinion… ">Could you fix this issue in the next OS, SOS? If you have a fix plan for the issue, please share the schedule.</textarea>
          <span class="count"><span class="cur">110</span>/9,999</span>
        </div>
        <p class="error-msg">You can write up to 999 characters. Please write within 999 characters.</p>
        <div class="comment-bottom">
          <!-- <div class="attached">
            <span class="name">screenshot.png</span><button class="delete-btn" type="button"><span class="sr-only">delete attached file</span></button>
          </div> -->
          <button class="apply-btn" type="button">Comment</button>
        </div>
      </div>
    </div>
  </div>
  <!-- /content-box -->

  </div>
</template>
<script>
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';

  export default {
    components: { DatePicker },
    data() {
      return {
        time1: null,
        format: "YY-MM-DD",
        lang: {
          formatLocale: {
            weekdaysMin: ['S ', 'M', 'T ', 'W', 'T', 'F', 'S'],
          },
        }
      };
    },
    methods: {
      selectPrev7Day (emit) {
        const start = new Date();
        const end = new Date();
        start.setTime(end.getTime() - 7 * 24 * 3600 * 1000);
        const date = [start, end];
        emit(date);
      },
      selectPrev30Day (emit) {
        const start = new Date();
        const end = new Date();
        start.setTime(end.getTime() - 30 * 24 * 3600 * 1000);
        const date = [start, end];
        emit(date);
      },
      selectPrev60Day (emit) {
        const start = new Date();
        const end = new Date();
        start.setTime(end.getTime() - 60 * 24 * 3600 * 1000);
        const date = [start, end];
        emit(date);
      },
      selectPrev90Day (emit) {
        const start = new Date();
        const end = new Date();
        start.setTime(end.getTime() - 90 * 24 * 3600 * 1000);
        const date = [start, end];
        emit(date);
      },
      toggleFooter (value, type) {
        if (type === 'date') {
          const footer = document.getElementsByClassName('mx-datepicker-footer')[0];
          footer.classList.add('on');
        }
      },
      open () {
        const filterBox = document.getElementsByClassName('mx-datepicker')[0];
        filterBox.classList.add('active');
      },
      close () {
        const filterBox = document.getElementsByClassName('mx-datepicker')[0];
        filterBox.classList.remove('active');
      },
      handleApply () {
        this.$refs.datepicker.closePopup();
      }
    },
  }
</script>
<style scoped>

/* common */
.sr-only { position: absolute; top: 0; left: 0; width: 0; height: 0; overflow: hidden; visibility: hidden; font-size: 0; line-height: 0; } 
/* /common */

/* =========== LAYOUT ========== */
.content-box { height: 100%; padding: 40px 24px; } 
.content-inner { max-width: 1000px; margin: auto; } 
@media all and (max-width: 1000px){
 .content-box { padding: 32px 24px 120px; } 
 }

/* =========== COMPONENTS ========== */
.h2 { display: block; margin-top: 20px; margin-bottom: 80px; font-family: SamsungSharpSans-Medium; font-size: 40px; font-weight: 500; line-height: 1.5; letter-spacing: -0.13px; color: #000; } 
.h3 { display: block; margin-top: 42px; padding: 22px 0; font-size: 20px; font-weight: 500; line-height: 1.2; letter-spacing: -0.1px; color: #000; font-family: SamsungSharpSans-Medium; } 

@media all and (max-width: 1000px){
 .h2 { margin-top: 0; margin-bottom: 64px; font-size: 36px; line-height: 1.22; letter-spacing: -0.1px; } 
 }
/* input */
.input-text { position: relative; padding: 0 12px; border-radius: 4px; border: solid 1px #d6d6d6; background-color: #fff; } 
.input-text.big { padding: 0 12px; } 
.input-text.search { padding-left: 32px; background: url(/images/input-search.png) no-repeat #fff 8px center / 16px 17px; } 
.input-text input[type="text"] { width: 100%; height: 30px; line-height: 20px; font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif; font-size: 14px; color: #363636; } 
.input-text input[type="text"] + button { display: none; position: absolute; right: 8px; top: 50%; transform: translateY(-50%); width: 16px; height: 16px; padding: 3px; line-height: 0; font-size: 0; } 
.input-text input[type="text"] + button img { max-width: 100%; } 
.input-text.active input[type="text"] + button { display: block; } 
.input-text.active.error input[type="text"] + button { display: none; } 
.input-text.active { padding-right: 32px; } 
.input-text.big input[type="text"] { height: 46px; font-size: 16px; line-height: 1.38; } 
.input-text.active { border-color: #0f42cf; } 
.input-text.error { border-color: #ec2000; padding-right: 36px; background: url(/images/error.png) no-repeat #fff calc(100% - 9px) center / 16px; } 
.input-text.big.error { padding-right: 48px; background-size: 24px; } 
.input-file { position: relative; border-radius: 4px; border: solid 1px #d6d6d6; } 
.input-file input[type="file"] { position: absolute; opacity: 0; cursor: pointer; height: 0; width: 0; } 
.input-file input[type="file"] + label { display: block; width: 32px; height: 32px; font-size: 0; line-height: 0; background: url(/images/attachment.png) no-repeat center transparent; background-size: 16px; cursor: pointer; } 
.textarea { width: 100%; height: 100px; font-size: 14px; line-height: 1.43; letter-spacing: -0.14px; color: #363636; resize: none; scrollbar-width: none; -ms-overflow-style: none; overflow-x: scroll; } 
.textarea::-webkit-scrollbar { display: none; } 
/* /input */
.comment-wrap { position: relative; padding: 24px 16px 16px; border-radius: 4px; background-color: #f7f7f7; } 
.comment-wrap .comment-head { position: relative; } 
.comment-head .issue-info { margin-right: 64px; } 
.comment-head .issue-info .no { display: inline-block; margin-right: 8px; margin-bottom: 8px; font-size: 16px; line-height: 1; letter-spacing: -0.11px; color: #6e6e6e; vertical-align: middle; } 
.comment-head .issue-info .input-text { display: inline-block; width: 200px; vertical-align: middle; margin-bottom: 8px; } 
.comment-head .input-file { position: absolute; top: 0; right: 0; } 
.comment-wrap .comment { position: relative; padding: 16px 16px 36px; border-radius: 4px; border: solid 1px #d6d6d6; background-color: #fff; } 
.comment-bottom { margin-top: 8px; font-size: 0; line-height: 0; } 
.comment.error { border-color: #ec2000; } 
.comment-wrap .error-msg { font-size: 14px; line-height: 1.43; letter-spacing: -0.14px; color: #ec2000; display: none; padding-left: 8px; margin-top: 8px; }
.comment.error + .error-msg { display: block; } 
.comment-bottom:after { content: ""; display: block; clear: both; } 
.comment-bottom .attached { position: relative; display: inline-block; padding: 13px 48px 13px 8px; border-radius: 4px; border: solid 1px #d6d6d6; } 
.comment-bottom .attached .name { display: inline-block; padding-left: 24px; font-size: 14px; line-height: 1.43; letter-spacing: -0.14px; color: #6e6e6e; background: url(/images/file.png) no-repeat left center; background-size: 16px; } 
.comment-bottom .attached .delete-btn { position: absolute; top: 50%; right: 8px; transform: translateY(-50%); width: 16px; height: 16px; background: url(/images/close-light.png) no-repeat center / cover; } 
.comment-bottom .apply-btn { float: right; width: 120px; margin-top: 8px; padding: 7px 24px; border-radius: 4px; border: solid 1px #d6d6d6; font-size: 14px; font-weight: bold; line-height: normal; color: #363636; font-family: SamsungOne;} 
.comment-bottom .apply-btn:hover:not([disabled]) { background-color: #d6d6d6; } 
.comment-wrap .comment .count { position: absolute; bottom: 8px; right: 12px; font-size: 14px; line-height: 1.43; letter-spacing: -0.14px; color: #9e9e9e; }
.comment-wrap .comment.active .count .cur { color: #363636; }

.table-filter { position: relative; margin-top: 40px; }
.table-filter .filter-item { position: relative; width: 200px; display: inline-block; vertical-align: top; } 
.filter-item.short { width: 160px; }
.filter-item + .filter-item { margin-left: 8px; }

@media all and (max-width: 1000px){
 .comment-bottom .attached { display: block; } 
 .comment-bottom .attached + .apply-btn { margin-top: 16px; }
.comment-head .issue-info .input-text { width: 160px; padding-top: 0; padding-bottom: 0; height: 42px; }
.comment-head .issue-info .input-text input[type="text"] {height: 40px;}
.input-file input[type="file"] + label { width: 40px; height: 40px; background-size: 24px; } 
.comment-bottom .apply-btn { padding: 10px 24px; font-size: 16px; }

 .table-filter .filter-item { display: block; width: 100%; }
 .filter-item.short { width: 100%; }
 .filter-item + .filter-item { margin-left: 0; margin-top: 16px; }
 }
 .input-text-wrap { position: relative; } 
.input-text-wrap .text { position: relative; display: block; margin-bottom: 8px; margin-right: 4px; padding-right: 8px; font-size: 14px; font-weight: bold; line-height: 1.43; letter-spacing: -0.14px; color: #6e6e6e; } 
.input-text-wrap .picker-wrap { display: inline-block; width: 260px; vertical-align: middle; } 
.input-text-wrap .select-wrap { display: inline-block; width: 200px; vertical-align: middle; } 
.input-text-wrap .selects > button { width: 100%; height: 48px; font-size: 16px; line-height: 1.38; color: #9e9e9e; } 
.input-text-wrap .selects > button.active + .absList { display: block; } 
.input-text-wrap .selects .absList { z-index: 10; } 
@media all and (max-width:1000px){
 .input-text-wrap .text { display: block; margin-right: 0; padding-right: 0; } 
 .input-text-wrap .select-wrap { width: 100%; } 
 }
/* filter-wrap */
.filter-wrap { margin-top: 40px; } 
.filter-box ul { display: flex; margin: 0 -4px; } 
.filter-box ul li { position: relative; flex: 1 1 0px; width: 16.66%; padding: 0 4px; } 
.filter-item { position: relative; text-align: left; } 
.filter-item .title { display: block; margin-bottom: 6px; font-size: 14px; font-weight: bold; line-height: 1.43; letter-spacing: -0.14px; color: #6e6e6e; } 
.filter-item .input-text.active + .dropdown-wrap { display: block; } 
.filter-item .selected-text { position: relative; display: block; padding: 5px 36px 5px 12px; border-radius: 4px; border: solid 1px #d6d6d6; font-size: 14px; line-height: 1.43; color: #363636; } 
.filter-item .selected-text:before { content: ""; position: absolute; top: 50%; right: 12px; transform: translateY(-50%); width: 16px; height: 16px; background: url(/images/arrow-light.png) no-repeat center / cover; } 
.filter-item .selected-text.active { border-color: #0f42cf; } 
.filter-item .selected-text.active:before { transform: translateY(-50%) rotate(180deg); } 
.filter-item .selected-text span { display: block; max-width: 100%; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; } 
.filter-item .selected-text.active + .dropdown-wrap { display: block; } 
.dropdown-wrap { display: none; position: absolute; top: calc(100% + 4px); left: 0; right: 0; background-color: #fff; z-index: 20; padding: 8px 0; border-radius: 4px; border: solid 1px #d6d6d6; max-height: 378px; overflow: auto; } 
.dropdown-wrap ul { display: block; margin: 0; } 
.dropdown-wrap ul li { flex: none; width: 100%; padding: 0; } 
.dropdown-wrap ul li a { display: block; padding: 10px 12px; color: #363636; font-size: 14px; line-height: 1.43; } 
.dropdown-wrap ul li button { display: block; padding: 10px 12px; color: #363636; font-size: 14px; line-height: 1.43; width: 100%; text-align: left; font-family: SamsungOne; } 
.dropdown-wrap ul li.recent a { padding-left: 40px; background: url(/images/icon_time.png) 16px center no-repeat; background-size: 16px; } 
.dropdown-wrap ul li:hover a { background-color: rgba(15,66,207,0.1); } 
.dropdown-wrap ul li:hover button { background-color: rgba(15,66,207,0.1); } 
.filter-selected { margin-top: 6px; padding: 24px; border: solid 1px #d6d6d6; border-radius:4px; } 
.filter-selected .textarea { height: 184px; font-size: 16px; line-height: 1.5; letter-spacing: normal; color: #363636; } 
.bottom { margin-top: 40px; text-align: center; } 
.reg-item + .bottom { margin-top: 60px; } 
.bottom ul { text-align: center; } 
.bottom ul li { display: inline-block; padding: 0 8px; } 
@media all and (max-width: 1000px){
 .attach-wrap.only { height: 330px; } 
 .filter-wrap { margin-top: 24px; } 
 .filter-box ul { display: block; margin: 0; } 
 .filter-box ul li { flex: none; width: 100%; padding: 0; } 
 .filter-box > ul > li + li { margin-top: 16px; } 
 .filter-selected { margin-top: 8px; } 
.filter-title {margin-bottom:0;}
 .bottom .filled-btn.big { width: 100%; } 
 .bottom .lined-btn.big { width: 100%; } 
 .bottom ul { text-align: center; margin: 0 -4px; } 
 .bottom ul li { display: inline-block; width: 50%; padding: 0 4px; } 
 .reg-item + .bottom { margin-top: 40px; } 

 .input-text input[type="text"] { height: 38px; }
.input-text input[type="text"] + button { right: 12px; }
 .input-text.active { padding-right: 36px; }
 .input-text.search { padding-left: 36px; background-position: 12px center; }
 .input-text input[type="text"] + button { right: 12px; }
 .filter-item .selected-text { padding-top: 8px; padding-bottom: 8px; } 
 .table-filter .filter-item .selected-text span { font-size: 16px; }
 }
/* datetimepicker */
.mx-datepicker-range {width: 100%; } 
.mx-datepicker >>> .mx-input {max-width: 100%; height: 32px;padding: 6px 56px 6px 12px; border-color: #d6d6d6;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;font-size: 14px; line-height: 1.43; letter-spacing: normal; color: #000; font-family: SamsungOne;background: #ffffff url(/images/ic-calendar.png) calc(100% - 12px) center no-repeat;background-size: 16px; box-shadow: none; } 
.mx-datepicker >>> .mx-input:hover {border-color: #d6d6d6; } 
.mx-datepicker >>> .mx-input:focus {border-color: #0f42cf; } 
.mx-datepicker >>> .mx-input::placeholder {font-weight: normal !important; } 
.mx-datepicker >>> .mx-icon-calendar {display: none; } 
.picker-wrap >>> .mx-icon-clear {right: 36px; font-size: 0; }
.clear-icon {display: block;width: 16px;height: 16px; }  
.mx-datepicker >>> .calendar-icon {display: block;width: 24px;height: 24px; } 
.mx-datepicker >>> .calendar-icon img, .clear-icon img { width: 100%; } 
.mx-datepicker.active .calendar-icon { opacity: 1; } 
.mx-icon-left:before, .mx-icon-right:before, .mx-icon-double-left:before, .mx-icon-double-right:before, .mx-icon-double-left:after, .mx-icon-double-right:after {width: 14px;height: 14px;margin-left: -4px;border-width: 3px 0 0 3px;border-color: #000; } 
.mx-calendar-panel-month .mx-icon-left:after, .mx-calendar-panel-month .mx-icon-right:after, .mx-calendar-panel-month .mx-icon-double-left:after, .mx-calendar-panel-month .mx-icon-double-right:after {display: none; } 
.mx-calendar-panel-year .mx-icon-left:after, .mx-calendar-panel-year .mx-icon-right:after, .mx-calendar-panel-year .mx-icon-double-left:after, .mx-calendar-panel-year .mx-icon-double-right:after {display: none; } 
.picker-wrap >>> .mx-input-wrapper .mx-icon-clear{display:block}



/* calendar */
.mx-datepicker-main {border-radius: 4px; } 
.mx-datepicker-header {padding: 12px 0;border-color: #ebebed; } 
.mx-datepicker-header .mx-btn { margin: 0 7px;padding: 2px 8px; border-radius: 4px;font-size: 12px; line-height: 1.67; letter-spacing: -0.12px; color: rgba(54,54,54,0.8);font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif; } 
.mx-datepicker-header .mx-btn:first-child {margin-left: 5px; } 
.mx-datepicker-header .mx-btn:hover { background-color: rgba(15,66,207,0.1); } 
.mx-datepicker-footer {display: none;padding: 12px 16px; } 
.mx-datepicker-footer.on {display: block; } 
.mx-datepicker-footer .mx-btn {padding: 5px 16px 4px; border-radius: 4px; border: solid 1px #0f42cf;color: #0f42cf;font-weight: bold;font-size: 12px;font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif;line-height: normal; } 
.mx-calendar {padding: 0 16px 32px; } 

/* header, footer */
.mx-calendar-header, .mx-time-header {margin-top: 16px;height: 36px;line-height: 36px; } 
.mx-calendar-header-label .mx-btn,
.mx-time-header .mx-btn,
.mx-calendar-header-label {font-size: 16px;font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif;font-weight: bold;color: #363636; } 
.mx-table th {font-size: 12px;font-weight: normal; color: #d6d6d6; } 
.mx-table-date td {color: #363636;font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif; } 
.mx-table-date .cell.not-current-month {color: #d6d6d6; } 
.mx-table-date .today {color: #0f42cf; } 
.mx-calendar-content .cell.active {border-radius: 4px;background-color: #0f42cf; } 
.mx-calendar-content .cell.in-range,
.mx-calendar-content .cell.hover-in-range,
.mx-calendar-content .cell:not(.active):hover {background-color: rgba(15,66,207,0.1); } 

/* time */
.mx-time-content {padding: 0 26px; } 
.mx-time-header {border: none; } 
.mx-time-column {margin: 0 5px;border: none; } 
.mx-time-column .mx-time-item {height: 24px;line-height: 24px;border-radius: 4px;color: #363636;font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif; } 
.mx-time-column .mx-time-item:hover {background-color: rgba(15,66,207,0.1); } 
.mx-time-column .mx-time-item.active {color: #fff;font-weight: normal;background-color: #0f42cf; } 
.mx-time-column .mx-time-list::after {display: none; } 

/* month, year */
.mx-calendar-panel-month,
.mx-calendar-panel-year {padding: 0 36px; } 
.mx-calendar-panel-month .mx-calendar-header, .mx-time-header,
.mx-calendar-panel-year .mx-calendar-header, .mx-time-header {margin: 16px -20px 0; } 
.mx-table.mx-table-month {height: 180px; } 
.mx-table-month .cell,
.mx-table-year .cell {padding: 0 4px;color: #363636;font-family: SamsungOne,"Apple SD Gothic Neo","Apple SD 고딕 Neo",AppleGothic,arial,sans-serif; } 
.mx-table-month .cell div,
.mx-table-year .cell div {padding: 5px;border-radius: 4px; } 
.mx-table-month .cell.active,
.mx-table-year .cell.active {background-color: transparent; } 
.mx-table-month .cell.active div,
.mx-table-year .cell.active div {padding: 5px 0;border-radius: 4px;background-color: #0f42cf; } 
.mx-table-month .cell:not(.active):hover,
.mx-table-year .cell:not(.active):hover {background-color: transparent;color: #363636; } 
.mx-table-month .cell:not(.active):hover div,
.mx-table-year .cell:not(.active):hover div {background-color: rgba(15,66,207,0.1); } 
/* /datetimepicker */
@media all and (max-width:1000px){
 .input-text-wrap .text { display: block; margin-right: 0; margin-bottom: 8px; padding-right: 0; } 
 .input-text-wrap .text:before { display: none; } 
 .input-text-wrap .picker-wrap { width: 100%; } 
 .mx-calendar,
 .mx-time { width: 100%; } 
 .mx-datepicker-popup { max-height: 80vh; overflow-x: auto; } 
 .input-text-wrap .select-wrap { width: 100%; } 

 .mx-datepicker >>> .mx-input { height: 42px; padding: 6px 84px 6px 16px; background-position: calc(100% - 16px) center; background-size: 24px; } 
 .picker-wrap >>> .mx-icon-clear {right: 52px; }
 .clear-icon { width: 24px;height: 24px; } 
 }

.article { position: relative; margin-top: 20px; border-top: 1px solid #ebebed; border-bottom: 1px solid #ebebed; }
.article .header { position: relative; padding: 16px;}
.article .issue-info:after { content: ""; display: block; clear: both;}
.article .issue-info li { position: relative;float: left; font-size: 14px; line-height: 1.14; letter-spacing: -0.14px; color: #363636; font-family: Arial; padding-right: 8px; margin-right: 8px;}
.article .issue-info li:before { content: ""; position: absolute; top: 50%; right: 0; transform: translateY(-50%); width: 1px; height: 12px; background-color: #9e9e9e;}
.article .issue-info li:last-child {padding-right: 0; margin-right: 0;}
.article .issue-info li:last-child:before {display: none;}
.article .comment-info {position: relative; margin-top: 24px;}
.article .comment-info:after { content: ""; display: block; clear: both;}
.article .comment-info .avatar {display: block; position: absolute; left: 0; top: 0; width: 24px; height: 24px; background-repeat: no-repeat; background-position: center; background-size: cover;}
.article .comment-info .right {position: relative; padding-left: 36px; padding-right: 40px;}
.article .comment-info .right:after {content: ""; display: block; clear: both;}
.article .comment-info .detail .email { font-family: Arial; font-size: 14px; font-weight: bold; line-height: 1.14; letter-spacing: -0.14px; color: #363636; padding-top: 4px; display: inline-block;}
.article .comment-info .detail .num { display: inline-block; font-family: Arial; font-size: 12px; line-height: 1.33; letter-spacing: -0.12px; color: #9e9e9e; padding: 2px 4px; background-color: #f7f7f7; margin-left: 8px; }
.article .comment-info .detail .date {float: right; font-family: Arial; font-size: 14px; line-height: 1.14; letter-spacing: -0.14px; color: #6e6e6e; padding-top: 4px;}
.article .comment-info .more {position: absolute; top: 0; right: 0; font-size: 0; line-height: 0; }
.article .comment-info .more > button {width: 24px; height: 24px; border-radius: 2px;}
.article .comment-info .more > button img {width: 100%;}
.article .comment-info .more > button.active {background-color: rgba(15, 66, 207, 0.1);}
.article .comment-info .more > button.active + .dropdown-wrap {display: block; width: 160px; left: auto; }

.article .comment { border-top: 1px solid #ebebed; padding: 16px 24px 24px; background-color: rgba(15,66,207,0.02);}
.article .comment p { font-family: Arial; font-size: 14px; line-height: 1.43; letter-spacing: -0.14px; color: #363636; word-wrap: break-word; word-break: break-word; }
.article .comment p + .attached-item {margin-top: 24px;}

.article .attached-item { position: relative; padding: 10px 16px; border: solid 1px #ebebed; background-color: #fff; width: 100%; } 
.article .attached-item .name { display: block; max-width: 100%; margin-right: 28px; padding: 0 0 0 28px; font-size: 14px; line-height: 1.43; text-overflow: ellipsis; overflow: hidden; max-height: 40px; -webkit-box-orient: vertical; -webkit-line-clamp: 2; display: -webkit-box; color: #0f42cf; background: url(/images/file.png) no-repeat left 2px; background-size: 16px; font-family: Arial; } 
.article .attached-item a:hover {text-decoration: underline;}
.article .attached-item button { position: absolute; top: 12px; right: 16px; width: 16px; height: 16px; line-height: 0; font-size: 0; } 
.article .attached-item button img { max-width: 100%; } 

.comment-list > .num { display: block; margin: 16px 0 8px; text-align: right;font-family: Arial; font-size: 14px; line-height: 1.43; letter-spacing: -0.1px; color: #9e9e9e;}
.comment-list .article { border-top: none; border-bottom: none; margin-top: 0;}
.comment-list > ul > li {border-top: 1px solid #ebebed;}
.comment-list .article .comment {background-color: transparent; border-top: none; padding-left: 68px; padding-top: 8px;}
.comment-list .article .comment-info {margin-top: 0;}
.comment-list .article .comment-info .avatar {width: 36px; height: 36px; margin-top: 2px;}
.comment-list .article .comment-info .right {padding-left: 52px;}
.comment-list .article .comment a {color: #0f42cf;}
.comment-list .article .comment a:hover {text-decoration: underline;}

@media all and (max-width:1000px){
  .article {margin-top: 0;}
  .article .issue-info li {line-height: 1.57;}
  .article .comment-info .right {padding-left: 40px;}
  .article .comment-info .detail .email {padding-top: 0;}
  .article .comment-info .detail .date {float: none; display: block; padding-top: 8px;}
  .article .comment {padding-left: 16px; padding-right: 16px;}

  .comment-list .article .comment-info .avatar {width: 24px; height: 24px; margin-top: 2px;}
  .comment-list .article .comment-info .right {padding-left: 40px;}
  .comment-list .article .comment {padding-left: 56px;}
  .comment-list .article .comment-info .avatar {margin-top: 0;}
  .article .comment-info .detail .email {display: block;}
  .article .comment-info .detail .num {margin-left: 0; margin-top: 8px;}
}
/* ============== table ============== */
.tableWrap { position: relative; width:100%; max-width:1000px; margin-top:40px; } 
.tableWrap .titArea { position: relative; padding:24px 0 16px; min-height: 68px; } 
.tableWrap .titArea .tit { font-size: 20px; font-weight: 500; line-height: 1.2; letter-spacing: -0.1px; color: #000; font-family: SamsungSharpSans-Medium; } 
.tableWrap .titArea .alignRight { position: absolute; right:0; bottom: 0; display:flex; align-items: flex-end; } 
.tableWrap .titArea .alignRight .excel { margin-left:8px; width: 96px; height: 32px; border-radius: 4px; border: solid 1px #d6d6d6; font-family: SamsungOne; font-size: 14px; font-weight: bold; text-align: center; color: #363636; } 
.tableWrap .titArea .alignRight .del { margin-left:8px; width: 96px; height: 32px; border-radius: 4px; border: solid 1px #d6d6d6; font-family: SamsungOne; font-size: 14px; font-weight: bold; text-align: center; color: #363636; } 
.tableWrap .titArea .alignRight .edit { margin-left:8px; width: 96px; height: 32px; border-radius: 4px; border: solid 1px #d6d6d6; font-family: SamsungOne; font-size: 14px; font-weight: bold; text-align: center; color: #363636; } 
.tableWrap .titArea .alignRight .add { margin-left:8px; width: 96px; height: 32px; border-radius: 4px; border: solid 1px #d6d6d6; font-family: SamsungOne; font-size: 14px; font-weight: bold; text-align: center; color: #363636; } 
.tableWrap.titOn { } 
.tableWrap.titOn .titArea { z-index:20; } 
.tableWrap.titOn .tableSt01 { position: relative; z-index:10; } 
.tableSt01 { } 
.tableSt01.headOn > table { z-index:10; } 
.tableSt01.headOn > .scroll { position: relative; z-index:9; } 
.tableSt01 table { table-layout: fixed;position: relative; } 
.tableSt01 thead th { position: relative;  background:#f7f7f7; border-bottom:1px solid #ebebed; text-align:left; } 
.tableSt01 thead th .inbox { position: relative; padding:20px 32px 20px 16px; } 
.tableSt01 thead th.file .inbox { padding: 12px 8px; } 
.tableSt01 thead th .inbox::after { content:''; width:1px; height:32px; position: absolute; right:0; top:50%; transform: translateY(-50%); background:#ebebed; } 
.tableSt01 thead tr th:last-child .inbox::after { display:none; } 
.innerTable.with-filter .tableSt01 thead th.file:before { content: ""; position: absolute; top: 0; right: -30px; bottom: 0; left: 0; background-color: #f7f7f7; z-index: -1; }
.tableSt01 thead th .str { font-size: 0; line-height: 0; } 
.innerTable.summary .tableSt01 thead th .str { min-height: 100%; } 
.tableSt01 thead th .str > strong { display: inline-block; font-size: 13px; font-weight: bold; line-height: 1.23; letter-spacing: -0.13px; color: #363636; } 
.tableSt01 thead th .str .sort { position: absolute; top: 50%; right: 8px; transform: translateY(-50%); width: 16px; font-size: 0; line-height: 0; } 
.tableSt01 thead th .str button img { width:100%; } 
.tableSt01 thead th .str .filter { position: absolute; top:50%; transform: translateY(-50%); right: 28px; font-weight: normal; font-size: 0; line-height: 0; } 
.tableSt01 thead th .str .filter button { width:16px; height: 16px; background: url(/images/filter.png) no-repeat center / cover; } 
.tableSt01 thead th .str .filter.active button { background-image: url(/images/filter-active.png); } 
.tableSt01 thead th .str .filter.active .dropdown-wrap { display: block; width: 160px; top: calc(100% + 24px); left: auto; right: -28px; } 
.tableSt01 thead th.center { text-align:center; } 
.tableSt01 thead th.center .inbox { padding:0; justify-content: center; display: flex; align-items: center; } .tableSt01 thead .only th .inbox { padding: 20px 8px 20px 16px; }
.tableSt01 thead .only th .inbox::after { height:32px; } 
.fileFlus { position: absolute; top:154px; right:-10px; z-index:30;} 
.fileFlus > button img { width:24px; } 
.fileFlus.curr .absList { display:block; z-index:20; } 
.fileFlus .absList { position: absolute; right:0; top:100%; width:214px; padding:8px 0; border:1px solid #d6d6d6; border-radius: 4px; box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12); background:#fff; display:none; } 
.fileFlus .absList .all { margin: 0 8px; padding:10px 0; border-bottom:1px solid #ebebed; } 
.fileFlus .absList ul { padding-top:8px; } 
.fileFlus .absList li { padding:10px 8px; } 
.fileFlus .absList li:hover { background:#e6ecfb; } 
.fileFlus .absList label { font-family: SamsungOne; font-size: 14px; font-weight:normal; line-height: 1.43; color: #363636; margin-left:8px; } 
.fileFlus .absList .btns { padding:8px 8px 0; display: flex; justify-content: space-between; margin-top:8px; } 
.fileFlus .absList .btns button { width:calc(50% - 4px); height: 32px; border-radius: 4px; } 
.fileFlus .absList .btns button.btnOk { font-size: 14px; font-weight: bold; letter-spacing: -0.14px; color: #ffffff; background-color: #0f42cf; } 
.fileFlus .absList .btns button.btnRe { font-size: 14px; font-weight: bold; color: #363636; background-color: #fff; border: solid 1px #d6d6d6; } 


.tableSt01 tbody td { border-bottom:1px solid #ebebed; text-align:left; vertical-align: middle; } 
.tableSt01 tbody td.center { text-align:center; } 
.tableSt01 tbody td.middle { vertical-align: middle; } 
.tableSt01 tbody td.ellipsis p { max-width: 100%; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; } 

.innerTable.with-filter .tableSt01 tbody .blues {display: none;}
.innerTable.with-filter .tableSt01 tbody .blues.curr {display: table-row;}
.tableSt01 tbody .blues {display: table-row;}
.tableSt01 tbody .blues.curr {display:table-row;}
.tableSt01 tbody .blues td { background-color: rgba(15, 66, 207, 0.03); } 
.tableSt01 tbody .blues td.removeBr { background-color:#fff; } 
.tableSt01 tbody .blues td.blue { background-color: rgba(15, 66, 207, 0.03); } 
.tableSt01 tbody td.removeBr { border-bottom:0; } 
.tableSt01 tbody td > div { padding:16px; } 
.tableSt01 tbody td > div .status { display: block; width: 88px; margin: auto; padding: 2px; border-radius: 4px; font-size: 12px; line-height: 1.67; letter-spacing: -0.17px; font-weight: bold; } 
.tableSt01 tbody td > div .status.complete { color: #52c51a; background-color: rgba(0,196,46,0.1); } 
.tableSt01 tbody td > div .status.progress { color: #faad14; background-color: rgba(255,187,0,0.1); } 
.tableSt01 tbody td.allTxt > div { padding:16px 16px 16px 24px; position: relative; } 
.tableSt01 tbody td.allTxt > div strong { display:block; font-family: SamsungOne; font-size: 14px; font-weight: bold; line-height: 1.43; letter-spacing: -0.14px; color: #6e6e6e; padding-bottom:8px; } 
.tableSt01 tbody td.allTxt > div .option { position: absolute; right:12px; top:18px; padding: 0; } 
.tableSt01 tbody td.allTxt > div .option.curr > button { background:#dde6fa; border-radius: 4PX; } 
.tableSt01 tbody td.allTxt > div .option.curr ul { display:block; } 
.tableSt01 tbody td.allTxt > div .option > button { width:24px; height:24px; border-radius: 4px; padding: 3px; } 
.tableSt01 tbody td.allTxt > div .option > button:hover { background-color: rgba(15, 66, 207, 0.1); } 
.tableSt01 tbody td.allTxt > div .option > button + button {  margin-left: 8px; }
.tableSt01 tbody td.allTxt > div .option > button img { width:16px; } 

.tableSt01 tbody td.allTxt > div .option ul { position: absolute; top:100%; right:0; width:140px; padding:8px 0; border:1px solid #d6d6d6; border-radius: 4px; box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12); background:#fff; display:none; } 
.tableSt01 tbody td.allTxt > div .option ul button { width:100%; height:40px; font-size: 14px; line-height: 1.43; letter-spacing: normal; color: #363636; text-align:left; padding:0 10px; font-family: SamsungOne; } 
.tableSt01 tbody td.allTxt > div .option ul button:hover { background:#e6ecfb; } 
/* .tableSt01 tbody td .openr { padding:6px; } */
.tableSt01 tbody td .openr { position: relative; padding-left: 20px; display: none; font-size: 14px; line-height: 1.29; letter-spacing: -0.1px; color: #363636; font-family: Arial; text-align: left; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; max-width: 100%; } 
.innerTable.with-filter .tableSt01 tbody td .openr { display: block; } 
.tableSt01 tbody td .openr { margin-left: -4px; padding-left: 24px; }
.tableSt01 tbody td .openr img { width:16px; vertical-align: middle; margin-right:8px; position: absolute; top: 50%; left: 0; transform: translateY(-50%); } 
.tableSt01 tbody td .openr.open img { transform: translateY(-50%) rotate(180deg); } 
.tableSt01 tbody td .file {     padding: 4px; font-size: 0; line-height: 0; border-radius: 3px; margin-left: -3px; } 
.tableSt01 tbody td .file:hover {     background: rgba(15,66,207,0.1); }
.tableSt01 tbody td .file img { width:16px; } 
.tableSt01 tbody td > div p { line-height: 1.29; letter-spacing: -0.1px; color: #363636; font-family: Arial; } 
.tableSt01 tbody td .openr + p { vertical-align: top; display: inline-block; max-width: calc(100% - 24px); } 
.tableSt01 tbody tr.blues td > div p { padding-right: 64px; } 
.tableSt01 tbody td > div p a { color:#0f42cf; letter-spacing: -0.14px; }
.tableSt01 tbody td > div p a:hover { text-decoration: underline; } 
.tableSt01 thead th .picker-wrap {display: block; width: 100%; margin-top: 10px;}
.tableSt01 thead th .mx-datepicker-range {width: 100%;}
.tableSt01 thead th >>> .mx-datepicker .mx-icon-calendar { display: none;}
.tableSt01 thead th >>> .mx-datepicker .mx-icon-clear {right: 26px; }
.tableSt01 thead th >>> .mx-input {height: 24px; border-color: #d6d6d6;background: #ffffff url(/images/ic-calendar.png) calc(100% - 8px) center no-repeat;background-size: 12px;padding: 0 48px 0 8px; font-family: SamsungOne; font-size: 13px; line-height: 1.54; letter-spacing: normal; box-shadow: none; max-width: 100%; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; color: #000;}
.tableSt01 thead th .clear-icon {width: 10px;height: 10px; }


.tableSt01 .scroll { max-height:257px; overflow-y:auto; } 
.innerTable.with-filter .tableSt01 .scroll { max-height:none; } 
.tableSt01 .scroll.long { max-height:478px; } 
.tableSt01 input[type=checkbox] { width:16px; height:16px; border:0; background:url(/images/icon_checkbox.png) no-repeat; margin:0; background-size:100%; } 
.tableSt01 input[type=checkbox]:checked { background:url(/images/icon_checkbox_on.png) no-repeat; margin:0; background-size:100%; } 
.tableSt01 .searchBox { margin-top:10px; position: relative; } 
.tableSt01 .searchBox .searchInput > span { display:block; position: relative; } 
.tableSt01 .searchBox .searchInput > span input[type=text] { border-radius: 4px; border: solid 1px #d6d6d6; background: #ffffff url(/images/icon_search.png) 8px center no-repeat; background-size:16px; height:24px; width:100%; padding:0 8px 0 28px; } 
.tableSt01 .searchBox .searchInput.curr > span input[type=text] { border-color: #0f42cf; } 
.tableSt01 .searchBox .searchInput.curr > span input[type=text] + button { display:block; } 
.tableSt01 .searchBox .searchInput > span button { position: absolute; right:8px; top:50%; transform: translateY(-50%); display:none; } 
.tableSt01 .searchBox .searchInput > span button img { width:10px; } 
.tableSt01 .searchBox .searchInput.curr .absWord { display:block; } 
.tableSt01 .searchBox .searchInput .absWord { position: absolute; left:0; top:28px; width:100%; border:1px solid #d6d6d6; border-radius: 4px; box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12); z-index:20; background:#fff; display:none; } 
.tableSt01 .searchBox .searchInput .absWord li button { width:100%; height:36px; font-size: 14px; line-height: 1.43; letter-spacing: normal; color: #363636; text-align:left; padding:0 10px; } 
.tableSt01 .searchBox .searchInput .absWord li button strong { font-weight:bold; } 
.tableSt01 .searchBox .searchInput .absWord li.time button { padding-left:40px; background:url(/images/icon_time.png) 16px center no-repeat; background-size: 16px; } 
.tableSt01 .searchBox .searchInput .absWord li button:hover { background:#e6ecfb; } 
.tableSt01 .searchBox .searchInput .absWord li.time button:hover { background:#e6ecfb url(/images/icon_time.png) 16px center no-repeat; background-size: 16px; } 
.tableSt01 .searchBox .searchInput .absWord .btns { padding:8px 8px 8px; display: flex; justify-content: space-between; margin-top:8px; display:none; } 
.tableSt01 .searchBox .searchInput .absWord .btns button { width:calc(100% - 40px); height: 32px; border-radius: 4px; } 
.tableSt01 .searchBox .searchInput .absWord .btns button.btnOk { font-size: 14px; font-weight: bold; letter-spacing: -0.14px; color: #ffffff; background-color: #0f42cf; } 
.tableSt01 .searchBox .searchInput .absWord .btns button.imgRe { width:32px; } 
.tableSt01 .searchBox .searchInput .absWord .btns button.imgRe img { width:32px; } 
.tableSt01 .searchBox > button { display:none; } 

.infoTable { display:flex; justify-content:flex-end; align-items: center; padding:16px; box-sizing: content-box; } 
.infoTable span { font-size: 12px; line-height: 1.5; letter-spacing: -0.09px; color: #9e9e9e; } 
.infoTable > * { margin-left:8px; } 
.infoTable span:first-child { margin-left: 0; } 
.infoTable > .btns { margin: -8px -4px -8px 8px; padding-left:12px; position: relative; text-align: right; } 
.infoTable > .btns::before { content:''; position: absolute; left:0; top:50%; transform: translateY(-50%); width:1px; height:16px; background:#ebebed; } 
.infoTable > .btns button { margin: 4px; vertical-align: middle; line-height:0; background-color: #fff; border-radius: 4px; border: 1px solid #d6d6d6; padding: 3px; } 
.infoTable > .btns button img { width:16px; } 
.infoTable > .btns button.prev img { transform: rotate(180deg); opacity: 0.2; } 
.selects { position: relative; } 
.selects > button { border-radius: 4px; border: solid 1px #d6d6d6; background-color: #ffffff; } 
.selects.curr ul { display:block; } 
.selects > ul { position: absolute; top:100%; left:0; width:100%; padding:8px 0; border:1px solid #d6d6d6; border-radius: 4px; box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12); display:none; background-color: #fff; margin-top: 4px; } 
.selects > ul button { width:100%; height:36px; font-size: 14px; line-height: 1.43; letter-spacing: normal; color: #363636; text-align:left; padding:0 10px; } 
.selects > ul button:hover { background:#e6ecfb; } 

.selects .absList { position: absolute; background:#fff; right:0; top:100%; width:100%; padding:8px 0; border:1px solid #d6d6d6; border-radius: 4px; box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12); background:#fff; display:none; z-index: 10; margin-top: 4px; } 
.selects.curr .absList { display:block; } 
.selects .absList .all { margin: 0 8px; padding:10px 0; border-bottom:1px solid #ebebed; } 
.selects .absList ul { padding-top:4px; } 
.selects .absList li { padding:10px 8px; } 
.selects .absList li:hover { background:#e6ecfb; } 
.selects .absList label { font-family: SamsungOne; font-size: 14px; font-weight:normal; line-height: 1.43; color: #363636; } 
.selects .absList .btns { padding:8px 8px 0; display: flex; justify-content: space-between; margin-top:8px; } 
.selects .absList .btns button { width:calc(50% - 4px); height: 32px; border-radius: 4px; font-family: SamsungOne; } 
.selects .absList .btns button.btnOk { font-size: 14px; font-weight: bold; letter-spacing: -0.14px; color: #ffffff; background-color: #0f42cf; } 
.selects .absList .btns button.btnRe { font-size: 14px; font-weight: bold; color: #363636; background-color: #fff; border: solid 1px #d6d6d6; }
.selects .absList input[type="checkbox"] { position: absolute; opacity: 0; cursor: pointer; height: 0; width: 0; } 
.selects .absList input[type="checkbox"] + label span { position: relative; display: inline-block; padding-left: 26px; font-size: 14px; line-height: 1.43; color: #363636; } 
.selects .absList input[type="checkbox"] + label span:before { content: ""; position: absolute; left: 0; top: 50%; transform: translateY(-50%); width: 16px; height: 16px; background: url(/images/icon_checkbox.png) no-repeat center / cover; } 
.selects .absList input[type="checkbox"]:checked + label span:before { background-image: url(/images/icon_checkbox_on.png) !important; } 

.selects.type02 > button { padding:0 36px 0 12px; position: relative; font-family: SamsungOne; font-size: 13px; line-height: 1.54; letter-spacing: normal; color: #363636; height:32px; text-align:left; } 
.selects.type02 > button::after { content:''; position: absolute; right:12px; top:50%; transform: translateY(-50%); width:16px; height:16px; background:url(/images/arrow-light.png) no-repeat; background-size:100%; } 
.selects.type02 > button.active::after { transform: translateY(-50%) rotate(180deg); }
.selects.type03 > button { width: 80px; padding:0 28px 0 8px; position: relative; font-family: SamsungOne; font-size: 13px; line-height: 1.54; letter-spacing: normal; color: #363636; height:24px; text-align:left; } 
.selects.type03 > button::after { content:''; position: absolute; right:8px; top:50%; transform: translateY(-50%); width:12px; height:12px; background:url(/images/icon_openr_off.png) no-repeat; background-size:100%; } 
.selects.type03 ul button { width:100%; height:40px; font-size: 14px; line-height: 1.43; letter-spacing: normal; color: #363636; text-align:left; padding:0 12px; font-family: SamsungOne; } 
.selects > button.off { color: #9e9e9e; } 


.tabSt01 { } 
.tabSt01 ul { display:flex; align-items: center; position: relative; } 
.tabSt01 ul::before { content:''; position: absolute; left:0; bottom:0; background:#d6d6d6; width:100%; height:2px; z-index: -1; } 
.tabSt01 ul button { height:52px; font-size: 16px; line-height: 1.5; color: #9e9e9e; padding:0 24px; text-transform: uppercase; font-family: SamsungOne; } 
.tabSt01 ul .curr button { color:#363636; border-bottom:2px solid #000; font-weight: bold; letter-spacing: -0.16px; } 


@media all and (max-width:1000px){
 .innerTable { width:100%; overflow-x:auto; } 
 .innerTable .scrollX { width:1000px; } 
 .tableSt01 .scroll { max-height: none; } 
 .tableSt01 thead .only th .inbox { padding-right:8px; } 
 .tableSt01 thead .only th .inbox .str { width:calc(100%) } 
 .tableSt01 .searchBox { margin-top:0px; position: static; } 
 .tableSt01 .searchBox .searchInput { display:none; } 
 .tableSt01 .searchBox .searchInput > span { display:block; position: relative; } 
 .tableSt01 .searchBox .searchInput > span input[type=text] { border-radius: 4px; border: solid 1px #d6d6d6; background: #ffffff url(/images/icon_search.png) 8px center no-repeat; background-size:16px; height:24px; width:100%; padding:0 8px 0 28px; } 
 .tableSt01 .searchBox .searchInput.curr > span input[type=text] { border-color: #0f42cf; } 
.tableSt01 .searchBox .searchInput.curr > span input[type=text] + button { display:block; } 
 .tableSt01 .searchBox .searchInput > span button { position: absolute; right:8px; top:50%; transform: translateY(-50%); display:none; } 
 .tableSt01 .searchBox .searchInput > span button img { width:10px; } 
 .tableSt01 .searchBox .searchInput.curr .absWord { display:block; } 
 .tableSt01 .searchBox .searchInput .absWord { position: absolute; left:0; top:28px; width:100%; border:1px solid #d6d6d6; border-radius: 4px; box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12); z-index:20; background:#fff; display:none; } 
 .tableSt01 .searchBox .searchInput .absWord li button { width:100%; height:36px; font-size: 14px; line-height: 1.43; letter-spacing: normal; color: #363636; text-align:left; padding:0 10px; } 
 .tableSt01 .searchBox .searchInput .absWord li button strong { font-weight:bold; } 
 .tableSt01 .searchBox .searchInput .absWord li.time button { padding-left:40px; background:url(/images/icon_time.png) 16px center no-repeat; background-size: 16px; } 
 .tableSt01 .searchBox .searchInput .absWord li button:hover { background:#e6ecfb; } 
 .tableSt01 .searchBox .searchInput .absWord li.time button:hover { background:#e6ecfb url(/images/icon_time.png) 16px center no-repeat; background-size: 16px; } 
 .tableSt01 .searchBox .searchInput .absWord .btns { display:block; display:flex; } 
 .tableSt01 .searchBox > button { display:block; position: absolute; right:8px; top:50%; transform: translateY(-50%); font-size:0; line-height:0; width:16px; height:16px; background:url(/images/icon_search.png) no-repeat; background-size:100%; } 
 .tableSt01 .curr .searchBox > button { background:url(/images/icon_search_on.png) no-repeat; background-size:100%; } 
 .tableSt01 .curr .searchBox .searchInput { display:block; position: absolute; right:8px; top:45px; width:150%; } 
 .tableSt01 .curr .searchBox .searchInput > span input[type=text] { height:40px; } 
 .tableSt01 .curr .searchBox .searchInput .absWord { display:block; top:44px; } 
.tableSt01 thead th .picker-wrap { position: absolute; right: 8px; top: 50%; transform: translateY(-50%); width: 16px; margin-top: 0; }
.tableSt01 thead th >>> .mx-input { height: 0; padding: 8px; width: 0; border: none; background-color: transparent; background-position: right center; cursor: pointer; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; background-size: 16px;}
 .tableSt01 thead th.file .inbox { padding-bottom: 15px; }
 .tableSt01 thead th.file .str { justify-content: initial; }
 
 
 .infoTable { background-color: #f7f7f7; } 
 .infoTable > * { margin-left:8px; } 

.tableWrap .titArea { min-height: 40px; padding-top: 8px; }
 .tableWrap .titArea .tit { font-size: 20px; font-weight: 500; line-height: 1.2; letter-spacing: -0.1px; color: #000; font-family: SamsungSharpSans-Medium; } 
 .tableWrap .titArea .alignRight { position: static; transform: translateY(0%); display:block; margin-top:16px; } 
 .tableWrap .titArea .alignRight .selects { display:inline-block; width:calc(50% - 4px); } 
 .tableWrap .titArea .alignRight .selects button { width:calc(100%) !important; height:40px; } 
 .tableWrap .titArea .alignRight .selects + .excel { width:calc(50% - 4px); height:40px; } 
 .tableWrap .titArea .alignRight .excel { margin-left:0; width: 100%; height: 40px;font-size: 16px; } 
 .tableWrap .titArea .alignRight .del { margin-left:8px; width: 96px; height: 32px; border-radius: 4px; border: solid 1px #d6d6d6; font-family: SamsungOne; font-size: 14px; font-weight: bold; text-align: center; color: #363636; } 
 .tableWrap .titArea .alignRight.basic .selects { display:block; width:100%; } 
 .tableWrap .titArea .alignRight.basic .del { margin-left:0; height:40px; margin-top:8px; width:calc(50% - 4px); } 
 .tableWrap .titArea .alignRight.basic .edit { margin-left:0; height:40px; margin-top:8px; width:calc(50% - 4px); } 
 .tableWrap .titArea .alignRight.basic .add { margin-left:0; margin-right: 8px; height:40px; margin-top:8px; width:calc(50% - 4px); } 
 .tableWrap .titArea .alignRight.basic .edit + .del { margin-left: 8px; } 
 .tableWrap .titArea .alignRight.basic .excel { height:40px; margin-top:8px; margin-left: 0; width:100%; } 
 .tableWrap .titArea .alignRight.basic.only button { margin-left:0; height:40px; margin-top:0; width:100%; } 
 .tableWrap .titArea .alignRight.basic button:nth-child(3) { margin-left:0; margin-top: 8px; width: 100%; } 
 .tableWrap .titArea .alignRight.basic.even button { width: calc(33.33% - 8px) !important; margin: 0 4px !important; } 
 .tableWrap .titArea .alignRight.basic.even { margin: 22px -4px 0; } 
 .tableSt01 tbody td .openr { display: inline-block; }
 .tableSt01 tbody .blues { display: none; }
.tableSt01 tbody td.allTxt > div .option { right: 19px; top: 16px; }
.tableSt01 tbody td.allTxt > div .option > button { border: 1px solid #d6d6d6; }
.selects.type03 > button { width: 72px; height: 32px; } 
.infoTable > .btns button { padding: 7px; }
.infoTable > .btns { margin-left: 8px; }
.selects.type02 > button { height: 40px; font-size: 16px; }
.selects .absList label { font-size: 16px; }
 }
</style>